<template>
  <div class="vacancy-stage" @click="stageClick">
    <div class="vacancy-stage__left">
      <Picture
        v-if="data.icon"
        :url="data.icon ? data.icon : ''"
        alt="icon"
        height="24"
        width="24"
        :class="[
          'vacancy-stage__picture',
          !activeStage ? 'vacancy-stage__picture--disabled' : ''
        ]"
      />
      <p
        :class="[
          'vacancy-stage__name',
          !activeStage ? 'vacancy-stage--disabled' : ''
        ]"
      >
        {{ data.name }}
      </p>
    </div>
    <p class="vacancy-stage__count">{{ data.counter }}</p>
  </div>
</template>

<script>
import Picture from 'Elements/Picture/Picture';
import { store } from '@/store';
import { INTENT_AREA } from '@/utils/constants';
import { parseIntent } from '@/utils/mixins';

export default {
  mixins: [parseIntent],
  props: {
    data: []
  },
  computed: {
    activeStage() {
      return this.data.state;
    }
  },
  methods: {
    stageClick() {
      const intents = this.data.intents;
      for (let index in intents) {
        const intent = intents[index];
        if (intent.intentArea == INTENT_AREA.RIGHT_PANEL) {
          const hiddenStages = [];
          //если при нажатии на этап он был активным - сохраняем его как скрытый
          if (
            intent.request?.request_params.hasOwnProperty('hidden_stage_ids[]')
          ) {
            hiddenStages.push(
              intent.request.request_params['hidden_stage_ids[]']
            );
          }
          //если до этого были выбраны другие этапы для скрытия - сохраняем и их
          store.commit('rightPanel/setParam', {
            name: 'hiddenStages',
            val: [
              ...hiddenStages,
              ...this.getHiddenStagesFromIntent(intents[index])
            ]
          });

          store.dispatch('rightPanel/getMetadata', {
            intentOrRequest: intent.request,
            newCheck: false
          });
        } else if (intent.intentArea == INTENT_AREA.SUBPANEL_UPLOAD) {
          store.dispatch('subpanels/updateDataForVacancyCandidates', intent);
        }
      }
    }
  },
  components: { Picture }
};
</script>

<style lang="scss" scoped>
.vacancy-stage {
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  &--disabled {
    color: $grey40 !important;
  }

  &__picture {
    filter: $greyPicture;

    &--disabled {
      filter: $lightGreyPicture;
    }
  }

  &__left,
  &__count {
    pointer-events: none;
  }

  &__left {
    display: flex;
    gap: 8px;
  }

  &__name {
    font-family: 'Roboto Medium';
    font-size: 16px;
    text-overflow: ellipsis;
    max-width: 223px;
    overflow: hidden;
    white-space: nowrap;
    color: $grey64;
  }

  &__count {
    font-family: 'Roboto Medium';
    color: $blue40;
  }
}
</style>
